import { render, staticRenderFns } from "./fadeCircles.vue?vue&type=template&id=6b5744ea&"
import script from "./fadeCircles.vue?vue&type=script&lang=js&"
export * from "./fadeCircles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports